import { v1 } from 'uuid';

type SliderMockDataType = {
    id: string;
    img: string;
    name: string;
    text: string;
};

const sliderMockData: SliderMockDataType[] = [
    {
        id: v1(),
        img: 'dmitri.jpg',
        name: 'Дмитрий Васильев',
        text: 'Давно хотели приобрести однотонное бордовое постельное белье из натурального материала. Какое же было счастье, что я нашёл этот магазин! Комплект безупречного качества, очень приятная ткань к телу, цвет не линяет при стирке и пока ещё не стал тусклее)) Удобно, что пододеяльник застегивается на молнию, размер идеально подходит для больших кроватей - простынь огромная и это большой + Удачи вам и благодарных клиентов!',
    },
    {
        id: v1(),
        img: 'lena.jpg',
        name: 'Лена Вернадская',
        text: 'Все прекрасно, начиная от оформления заказа (консультация, отзывчивость, просто приятное общение), все сроки соблюдены, просто шикарный подарок в плане упаковки, качество неимоверное,  индивидуальные размеры четко подходят))) Жду новых дизайнов!!!',
    },
    {
        id: v1(),
        img: 'svetlana.jpg',
        name: 'Светлана Богатырева',
        text: 'Твердая пятерка! Ткань очень качественная, плотная и при этом  приятная на ощупь, аккуратные строчки. Цвет белья на сайте такой же,  как и в живую. Заказывала через сайт, мне быстро перезвонили, быстро  отправили. Приятно, когда к клиентам относятся с любовью даже в  мелочах.. красиво упаковать и оформить. Обязательно закажу себе еще  пару комплектов. Соотношение цена/качество выше всяческих похвал',
    },
    {
        id: v1(),
        img: 'mark.jpg',
        name: 'Марк Адинтур',
        text: 'Все очень понравилось: прекрасное обслуживание, быстрое выполнение заказа даже под индивидуальные размеры, которые тоже были точно соблюдены; отличное качество ткани, приятное к телу, и цвета потрясающие! Большое спасибо, буду охотно заказывать ещё и рекомендовать знакомым!',
    },
    {
        id: v1(),
        img: 'kris.jpg',
        name: 'Кристина Ставицкая',
        text: 'Хочу поблагодарить сотрудников компании за внимание, терпение и пунктуальность. Заказывала перед Новым годом два комплекта из сатина разных размеров. Белье выше всяческих похвал! Ткань, исполнение - супер. Упаковка - та еще "стильная штучка. А микроприщепочки... Примите искреннюю благодарность от нашей семьи. Благодарных покупателей Вам, будьте здоровы!',
    },
];

export default sliderMockData;
